import * as React from "react";
const SvgFiRrAxe = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-axe_svg__a)">
      <path
        fill="#062147"
        d="M23.53 6.77a2.01 2.01 0 0 0-1.418-.713c-.759-.045-2.074-.214-2.927-.828l1.521-1.521a.999.999 0 1 0-1.414-1.414L17.75 3.836l-1.946-1.952a2.98 2.98 0 0 0-2.123-.883h-.003a2.98 2.98 0 0 0-2.12.879L9.878 3.558a3.006 3.006 0 0 0-.004 4.239l1.955 1.961L.293 21.293a.999.999 0 1 0 1.414 1.414l11.511-11.511c.608.849.783 2.167.832 2.929.036.545.296 1.059.716 1.409.362.302.821.466 1.29.466 4.194-.482 7.445-3.517 7.931-7.71a2.02 2.02 0 0 0-.457-1.52m-7.484 7.226c-.09-1.388-.45-3.297-1.656-4.502l-3.099-3.109a1 1 0 0 1 .001-1.413l1.678-1.678a1 1 0 0 1 .708-.293c.268 0 .52.105.708.295L17.48 6.4c1.217 1.218 3.125 1.571 4.518 1.659-.38 3.287-2.659 5.563-5.954 5.937zm.01 2.004c-.077.008.075 0 0 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-axe_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAxe;
